import { combineReducers } from "redux";

import auth from './auth';
import users from './user';
import benches from './benches';
import videos from './video';



export default combineReducers({ auth, users, benches, videos });
